import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Lock } from 'lucide-react';
import { adminLogin, setToken } from '../../api';
import { toast } from 'sonner';

export const AdminLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await adminLogin(password);
      setToken(token);
      toast.success('Bem-vindo, Rustem.');
      onSuccess();
    } catch (err) {
      toast.error('Password incorreta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-14 h-14 border border-stone-300 mb-6">
            <Lock className="w-5 h-5 text-stone-700" strokeWidth={1.5} />
          </div>
          <p className="text-xs tracking-[0.2em] uppercase text-stone-500 font-medium">Acesso reservado</p>
          <h1 className="text-3xl font-light text-stone-900 mt-3" data-testid="admin-login-title">
            Painel <span className="italic font-serif">Rustem</span>
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8" data-testid="admin-login-form">
          <div>
            <Label htmlFor="password" className="text-xs tracking-wider uppercase text-stone-500 font-medium">
              Password
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              data-testid="admin-password-input"
              className="mt-3 border-0 border-b border-stone-300 rounded-none px-0 focus-visible:ring-0 focus:border-stone-900 bg-transparent"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full bg-stone-900 hover:bg-stone-800 text-white font-medium py-6 text-sm tracking-wide rounded-none"
          >
            {loading ? 'A entrar...' : 'Entrar'}
          </Button>
        </form>
      </div>
    </div>
  );
};
